import { Trans } from '@i18n';
import { Checkbox, FormControlLabel, FormGroup, Stack } from '@mui/material';
import { memo, useCallback } from 'react';
import Collapsible from '../../common/Collapsible';
import { useBuildingFilters } from '../BuildingFiltersProvider';

function SlfCompliant() {
  const { filters, setFilters } = useBuildingFilters();

  const handleToggle = useCallback(
    (value: boolean, isChecked: boolean) => {
      void setFilters((prev) => ({
        ...prev,
        slfCompliant: isChecked ? value : null,
      }));
    },
    [setFilters],
  );

  return (
    <Collapsible title={<Trans i18nKey="General_SLFCompliant" />}>
      <Stack spacing={1} mt={-1}>
        <FormGroup
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
            gap: 1,
            width: '100%',
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={filters.slfCompliant === true}
                onChange={(e) => handleToggle(true, e.target.checked)}
              />
            }
            label={<Trans i18nKey="General_Yes" />}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={filters.slfCompliant === false}
                onChange={(e) => handleToggle(false, e.target.checked)}
              />
            }
            label={<Trans i18nKey="General_No" />}
          />
        </FormGroup>
      </Stack>
    </Collapsible>
  );
}

export const SlfCompliantFilter = memo(SlfCompliant);
